import './CampaignBlock.scss';
import React from 'react';
function CampaignBlock({ image, text }) {
    return (React.createElement("div", { className: "campaign-block" },
        React.createElement("img", { className: "campaign-block__image", src: image }),
        React.createElement("p", { className: "campaign-block__text" }, text)));
}
export default CampaignBlock;
